import React from 'react';

export default function Footer() {
  return (
    <footer className="bg-[#0E0E0E] border-t border-dark-4 pt-16 px-[8%] lg:px-[12%] pb-8 md:pb-8 pb-24">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-16 mb-12">
        <div className="md:col-span-2">
          <div className="font-condensed font-black text-3xl uppercase mb-2 text-white">
            Eastern Shore<br/><span className="text-white">Junk Removal</span>
          </div>
          <div className="text-sm text-text-muted mb-5">Local • Trusted • Affordable</div>
          
          <div className="flex flex-col gap-1">
            <a href="tel:4433592010" className="text-gold no-underline font-semibold text-[15px]">📞 443-359-2010</a>
            <a href="mailto:shorejunk1111@gmail.com" className="text-gold no-underline font-semibold text-[15px]">✉ shorejunk1111@gmail.com</a>
          </div>
        </div>

        <div>
          <div className="font-condensed font-extrabold text-sm uppercase tracking-[0.12em] text-text-muted mb-4">Services</div>
          <ul className="list-none flex flex-col gap-2.5 text-sm text-text-muted">
            <li>Furniture Removal</li>
            <li>Appliance Removal</li>
            <li>Garage Clean-outs</li>
            <li>Estate Clean-outs</li>
            <li>Yard Debris Removal</li>
          </ul>
        </div>

        <div>
          <div className="font-condensed font-extrabold text-sm uppercase tracking-[0.12em] text-text-muted mb-4">Areas Served</div>
          <ul className="list-none flex flex-col gap-2.5 text-sm text-text-muted">
            <li>Salisbury</li>
            <li>Ocean City</li>
            <li>Berlin</li>
            <li>Fruitland</li>
            <li>& Eastern Shore</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-dark-4 pt-6 flex flex-col md:flex-row justify-between gap-3 text-[13px] text-dark-4">
        <div>© {new Date().getFullYear()} Eastern Shore Junk Removal. All rights reserved.</div>
        <div>Serving the Eastern Shore of Maryland</div>
      </div>
    </footer>
  );
}